// `deepReplace` takes a root data structure and a "swap map". It recursively
// walks any object keys or array elements of the root, replacing any value
// matching a key from the swap map with the corresponding value in the swap
// map. For example:
// deepReplace(
//   [false, {foo: false, bar: true}, 1, 2, 3],
//   new Map([[false, 'NOPE']])
// );
// Would return:
// ['NOPE', {foo: 'NOPE', bar: true}, 1, 2, 3]
const deepReplace = (root, swapMap) => {
  const newValue = swapMap.has(root) ? swapMap.get(root) : root;
  if (typeof newValue !== "object" || !newValue) return newValue;
  if (Array.isArray(newValue)) {
    return newValue.map((element) => {
      return deepReplace(element, swapMap);
    });
  } else {
    const newObj = {};
    for (const key of Object.keys(newValue)) {
      const value = newValue[key];
      newObj[key] = deepReplace(value, swapMap);
    }
    return newObj;
  }
};

export default deepReplace;
